import storage from 'good-storage'
const BROWSE_KEY = '__BROWSE__'

function insertArrey(arr, val, compare) {
    const index = arr.findIndex(compare)
    if (index >= 0) {
        arr.splice(index, 1)   
    }
    arr.push(val)
}
export function saveBrowse(query) {
    let browses = storage.get(BROWSE_KEY, [])
    insertArrey(browses, query, (item) => {
        return item === query
    })
    storage.set(BROWSE_KEY, browses)
    return browses
}

export function loadBrowse() {
    return storage.get(BROWSE_KEY, [])
}